export default "__VITE_ASSET__CTLveGZI__"